import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { MobileContainer } from '../RecommendedCreditScore/components/Mobile.container';
import { CommonSkeleton } from './components/CommonSkeleton';
import { SKELETON_CREDIT_SCORE_CONTAINER, SKELETON_CREDIT_SCORE_LINE, SKELETON_CREDIT_SCORE_TEXT, SKELETON_FREE_CREDIT_SCORE } from './constants';
export function RecommendedCreditScoreMobileSkeleton() {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      display: {
        xs: "flex",
        md: "none"
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mx: 3,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      flexGrow: 1,
      mt: {
        xs: 0.3,
        sm: 1
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      columnGap: 1,
      height: 60
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CommonSkeleton width="1.5rem" height="1rem" sx={{
      gridColumn: 3,
      gridRow: 1,
      alignSelf: "center"
    }} data-testid={SKELETON_CREDIT_SCORE_CONTAINER} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Box sx={{
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gridColumn: 4,
      gridRow: 1
    }}><CommonSkeleton width="1.5rem" height="1rem" data-testid={SKELETON_CREDIT_SCORE_CONTAINER} /></Box>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CommonSkeleton height="0.75rem" sx={{
      gridColumn: 1,
      gridRow: 2
    }} data-testid={SKELETON_CREDIT_SCORE_LINE} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <CommonSkeleton height="0.75rem" sx={{
      gridColumn: 2,
      gridRow: 2
    }} data-testid={SKELETON_CREDIT_SCORE_LINE} />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CommonSkeleton height="0.75rem" sx={{
      gridColumn: 3,
      gridRow: 2
    }} data-testid={SKELETON_CREDIT_SCORE_LINE} />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <CommonSkeleton height="0.75rem" sx={{
      gridColumn: 4,
      gridRow: 2
    }} data-testid={SKELETON_CREDIT_SCORE_LINE} />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Grid sx={t2}>{t3}{t4}{t5}{t6}{t7}{t8}<CommonSkeleton width="100%" height="1rem" sx={{
        mt: 1,
        gridColumnStart: 2,
        gridColumnEnd: "span 3",
        gridRow: 3
      }} data-testid={SKELETON_CREDIT_SCORE_TEXT} /></Grid>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      display: "flex",
      width: "100%",
      flexWrap: "wrap",
      mt: 1
    };
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <MobileContainer additionalProps={t0}><Box sx={t1}>{t9}<Box sx={t10} data-testid={SKELETON_FREE_CREDIT_SCORE}><CommonSkeleton width="7.95rem" height="1.25rem" /><CommonSkeleton width="5.18rem" height="1.25rem" /></Box></Box></MobileContainer>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
}